module.exports = __webpack_public_path__ + "assets/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4kaVIGxA-fcdecd.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4kaVIGxA.woff2
// module id = 852
// module chunks = 2